import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getStorage, setStorage } from '../../Utils/common';
import { getDashboardData } from '../../Utils/api';
import { BoxWrapper } from '../../style';
import Alert from '../../components/ui/Alert';

function ApplicationComplete() {
    const [message, setMessage] = useState("");
    const [leadId, setLeadId] = useState("");
    const [applicationStatus, setApplicationStatus] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        // Get lead_id from localStorage
        const storedLeadId = getStorage("lead_id");
        const storedStatus = getStorage("application_status");
        
        if (storedLeadId) {
            setLeadId(storedLeadId);
        }
        
        if (storedStatus) {
            setApplicationStatus(storedStatus);
        }

        // Check application status from backend
        checkApplicationStatus();
    }, []);

    const checkApplicationStatus = async () => {
        try {
            const params = { profile_id: getStorage("cust_profile_id") || "" };
            const response = await getDashboardData(params);
            
            if (response?.data?.Status === 1) {
                const profileData = response?.data?.Data?.profile_details;
                const backendLeadId = profileData?.lead_id;
                const backendStatus = profileData?.application_submitted;
                
                if (backendLeadId) {
                    setLeadId(backendLeadId);
                    setStorage("lead_id", backendLeadId);
                }
                
                if (backendStatus) {
                    setApplicationStatus(backendStatus);
                    setStorage("application_status", backendStatus);
                }
            }
        } catch (error) {
            console.log("Error checking application status:", error);
        }
    };

    const handleGoToDashboard = () => {
        navigate('/my-dashboard/');
    };

    const handleContactSupport = () => {
        // You can add contact support functionality here
        window.open('tel:+91-9643655535', '_self');
    };

    return (
        <>
            <BoxWrapper className="w100">
                <div className="formmainBox flex">
                    <div className="left"></div>
                    <div className="right">
                        <div style={{ textAlign: 'center', padding: '40px 20px' }}>
                            {/* Success Icon */}
                            <div style={{ 
                                fontSize: '80px', 
                                color: '#28a745', 
                                marginBottom: '20px' 
                            }}>
                                ✅
                            </div>
                            
                            {/* Main Heading */}
                            <h1 style={{ 
                                color: '#28a745', 
                                fontSize: '28px', 
                                marginBottom: '15px',
                                fontWeight: '600'
                            }}>
                                Application Submitted Successfully!
                            </h1>
                            
                            {/* Application ID */}
                            {leadId && (
                                <div style={{ 
                                    backgroundColor: '#f8f9fa', 
                                    border: '2px solid #28a745',
                                    borderRadius: '10px',
                                    padding: '20px',
                                    margin: '20px 0',
                                    display: 'inline-block'
                                }}>
                                    <h3 style={{ 
                                        color: '#333', 
                                        fontSize: '18px', 
                                        margin: '0 0 10px 0',
                                        fontWeight: '500'
                                    }}>
                                        Your Application ID
                                    </h3>
                                    <div style={{ 
                                        fontSize: '24px', 
                                        fontWeight: 'bold', 
                                        color: '#28a745',
                                        letterSpacing: '2px'
                                    }}>
                                        {leadId}
                                    </div>
                                </div>
                            )}
                            
                            {/* Message */}
                            <div style={{ 
                                backgroundColor: '#e7f3ff', 
                                border: '1px solid #b3d9ff',
                                borderRadius: '10px',
                                padding: '25px',
                                margin: '20px 0',
                                maxWidth: '600px',
                                marginLeft: 'auto',
                                marginRight: 'auto'
                            }}>
                                <p style={{ 
                                    fontSize: '18px', 
                                    color: '#333', 
                                    margin: '0 0 15px 0',
                                    lineHeight: '1.6'
                                }}>
                                    🎉 <strong>Congratulations!</strong> Your loan application has been successfully submitted.
                                </p>
                                <p style={{ 
                                    fontSize: '16px', 
                                    color: '#666', 
                                    margin: '0 0 15px 0',
                                    lineHeight: '1.5'
                                }}>
                                    Our teammate will contact you soon for further processing and verification.
                                </p>
                                <p style={{ 
                                    fontSize: '14px', 
                                    color: '#888', 
                                    margin: '0',
                                    fontStyle: 'italic'
                                }}>
                                    Please keep your Application ID handy for future reference.
                                </p>
                            </div>
                            
                            {/* Status Info */}
                            <div style={{ 
                                backgroundColor: '#fff3cd', 
                                border: '1px solid #ffeaa7',
                                borderRadius: '8px',
                                padding: '15px',
                                margin: '20px 0',
                                maxWidth: '500px',
                                marginLeft: 'auto',
                                marginRight: 'auto'
                            }}>
                                <p style={{ 
                                    fontSize: '14px', 
                                    color: '#856404', 
                                    margin: '0',
                                    fontWeight: '500'
                                }}>
                                    📋 <strong>Status:</strong> Under Review
                                </p>
                                <p style={{ 
                                    fontSize: '13px', 
                                    color: '#856404', 
                                    margin: '5px 0 0 0'
                                }}>
                                    We will process your application within 24-48 hours.
                                </p>
                            </div>
                            
                            {/* Action Buttons */}
                            <div style={{ 
                                display: 'flex', 
                                gap: '15px', 
                                justifyContent: 'center',
                                marginTop: '30px',
                                flexWrap: 'wrap'
                            }}>
                                <button
                                    onClick={handleGoToDashboard}
                                    style={{
                                        backgroundColor: '#007bff',
                                        color: 'white',
                                        border: 'none',
                                        padding: '12px 25px',
                                        borderRadius: '6px',
                                        fontSize: '16px',
                                        fontWeight: '500',
                                        cursor: 'pointer',
                                        transition: 'background-color 0.3s ease'
                                    }}
                                    onMouseOver={(e) => e.target.style.backgroundColor = '#0056b3'}
                                    onMouseOut={(e) => e.target.style.backgroundColor = '#007bff'}
                                >
                                    Go to Dashboard
                                </button>
                                
                                <button
                                    onClick={handleContactSupport}
                                    style={{
                                        backgroundColor: '#28a745',
                                        color: 'white',
                                        border: 'none',
                                        padding: '12px 25px',
                                        borderRadius: '6px',
                                        fontSize: '16px',
                                        fontWeight: '500',
                                        cursor: 'pointer',
                                        transition: 'background-color 0.3s ease'
                                    }}
                                    onMouseOver={(e) => e.target.style.backgroundColor = '#218838'}
                                    onMouseOut={(e) => e.target.style.backgroundColor = '#28a745'}
                                >
                                    Contact Support
                                </button>
                            </div>
                            
                            {/* Contact Info */}
                            <div style={{ 
                                marginTop: '30px',
                                fontSize: '14px',
                                color: '#666'
                            }}>
                                <p style={{ margin: '5px 0' }}>
                                    📞 <strong>Phone:</strong> +91-9643655535
                                </p>
                                <p style={{ margin: '5px 0' }}>
                                    📧 <strong>Email:</strong> info@Udhaarportal.com
                                </p>
                            </div>
                        </div>
                        
                        <Alert setMessage={setMessage} message={message} />
                    </div>
                </div>
            </BoxWrapper>
        </>
    );
}

export default ApplicationComplete;
